'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _i18n = require('../helpers/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _ = require('.');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Page = function Page(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      backButtonAction = _ref.backButtonAction,
      className = _ref.className,
      layout = _ref.layout,
      children = _ref.children;

  return _react2.default.createElement(
    'article',
    { className: 'Page ' + (className || '') },
    (title || backButtonAction) && _react2.default.createElement(
      'header',
      null,
      backButtonAction && _react2.default.createElement(_.Button, { title: (0, _i18n2.default)('allEvents'), iconLeft: 'chevronLeft', type: 'borderless', action: backButtonAction }),
      title && _react2.default.createElement(
        'h1',
        null,
        title
      ),
      subtitle && _react2.default.createElement(
        'h2',
        null,
        subtitle
      )
    ),
    layout === 'custom' ? children : _react2.default.createElement(
      'section',
      { className: 'content ' + layout },
      _react2.default.createElement(
        'div',
        { className: 'body' },
        children
      )
    )
  );
};

Page.propTypes = {
  /**
   * The page title.
   */
  title: _propTypes2.default.string,
  /**
   * The page subtitle.
   */
  subtitle: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  /**
   * If present, shows a back button that triggers the provided action.
   */
  backButtonAction: _propTypes2.default.func,
  /**
   * The CSS class of the article element.
   */
  className: _propTypes2.default.string,
  /**
   * The layout to use for the content section
   */
  layout: _propTypes2.default.oneOf(['narrow', 'wide', 'custom']),
  /**
   * The page content.
   */
  children: _propTypes2.default.any
};

Page.defaultProps = {
  backButton: false,
  layout: 'narrow'
};

exports.default = Page;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/Page.js
// module id = 280
// module chunks = 0